module.exports = __webpack_public_path__ + "media/applicants/header-fb098a69.jpg";